<template>
  <div class="realEstatePanel">
    <div class="mt-2" v-if="loaded">
      <validation-observer ref="refFormObserver">
        <!-- Header: Personal Info -->
        <div class="d-flex">
          <feather-icon icon="PackageIcon" size="19"/>
          <h4 class="mb-0 ml-50">
            {{ msg('New Whitelabel') }}
          </h4>
        </div>


        <!-- Form: Personal Info Form -->
        <b-row class="mt-1">
          <b-col cols="12" md="12" lg="12">
            <b-form-group :label="msg('Branch')" label-for="product-branch">
              <validation-provider #default="{ errors }" :name="msg('Branch')" rules="required">
                <v-select
                    :dir="isRTL ? 'rtl' : 'ltr'"
                    v-model="whitelabel.buid"
                    :options="allBranches"
                    class="w-100"
                    label="name"
                    :reduce="(branch) => branch.id"
                    :clearable="false"

                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>


        </b-row>
      </validation-observer>
    </div>
    <div v-else-if="this.error != null">
      <b-alert show variant="danger"><i class="fas fa-exclamation-triangle mr-3"></i>
        <strong>{{ error }}</strong>
      </b-alert>
    </div>
    <div v-else>
      <div style="min-height: 300px;text-align: center">
        <div style="margin-top: 20%">
          <b-spinner label="Spinning"/>
          {{ msg('loading') }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'whitelabelPanel',
  components: {
  },
  data() {
    return {
      loaded: false,
      error: null,
      whitelabelId: 0,
      whitelabel: {
        company: '',
      },

      //Listeners
      listeners: {
        submit: () => {
        }
      }
    }
  },
  props: {
    id: Number,
  },
  watch: {
    id: function () { // watch it
      this.onLoad()
      this.error = null
    }
  },
  computed: {
    ...mapGetters('data', ['getAllBranches']),
    allBranches() {
      return Object.values(this.getAllBranches)
    },

  },
  created() {

    this.onLoad()
    this.$root.$on('crm::submitWhitelabel', (this.listeners.submit = () => {
      this.submit()
    }))
  },
  beforeDestroy() {
    this.$root.$off('crm::submitWhitelabel', this.listeners.submit)
  },
  methods: {
    ...mapActions('whitelabel', {
      _register: 'addWhitelabel',
    }),
    onLoad() {
      this.loaded = true
    },

    createWhitelabel() {
      let $this = this
      this.$refs['refFormObserver'].validate().then(valid => {
        if (!valid)
          return;
        $this._register(this.whitelabel)
            .then(
                (id) => {

                  $this.whitelabelId = id
                  $this.$emit('submitted', {status: true, server: id, id})
                  $this.$router.push('/whitelabel/edit/' + id)

                },
                (a) => $this.$emit('submitted', {
                  status: false,
                  server: a
                })
            )
      })
    },

    validate(field) {
      return this.$v.whitelabel[field] != null && this.$v.whitelabel[field].$error === true
    }
    ,
    submit() {
      return this.createWhitelabel()
    }

  },

}
</script>


